import 'css-chunksrc/client/pages/projectPage/timeSheetPage/loader/allocation/recordList/record/styles.scss';export default {
  "record": "_record_19xqa_1",
  "input": "_input_19xqa_9"
};